export default "__VITE_ASSET__Dfqo1bb6__"